import hyperdom from 'hyperdom'
import * as countries from 'root-config/resources/countries/index.js'
import BasePaymentMethod from '../methods/basePaymentMethod.jsx'
import ZipMoneyPaymentMethod from '../methods/zipMoney.jsx'
import assetPath from '../../../../assetPath.js'

export default class ZipMoney extends BasePaymentMethod {
  constructor (payment) {
    super(payment)
    const method = new ZipMoneyPaymentMethod(payment)
    this.paymentMethods = {
      selected: method,
      eligible: [method],
    }
    this.enabledCountries = ['au']
    this.label = payment.config.zipMoney.label
    this.bullets = payment.config.zipMoney.bullets
  }

  eligible () {
    return this.payment.features.zipMoney
  }

  success () {
    this.paymentMethods.selected.success()
  }

  referred (referenceNumber) {
    this.paymentMethods.selected.referred(referenceNumber)
    this.payment.paymentOptions.selected = this.payment.paymentOptions.eligible[0]
  }

  failed () {
    this.paymentMethods.selected.failed()
    this.payment.paymentOptions.selected = this.payment.paymentOptions.eligible[0]
  }

  declined () {
    this.hasFailed = true
    this.paymentMethods.selected.declined()
    this.payment.paymentOptions.selected = this.payment.paymentOptions.eligible[0]
  }

  closed () {
    this.payment.paymentOptions.selected = this.payment.paymentOptions.eligible[0]
  }

  amount () {
    return this.payment.booking.booking.paymentOptions.full.amount
  }

  zipMoneyText (generallyAvailable, availableInCountry) {
    if(generallyAvailable && availableInCountry) {
      return  <ul class='payment-options__details u-margin-bottom-medium'>
        {this.bullets.map(bullet => (<li class='payment-options__pros'>{bullet}</li>))}
      </ul>
    } else {
      if (!availableInCountry) {
        return <div class='payment-options__details u-margin-bottom-medium'>
          Zip Money is only available where the lead passenger is a resident of Australia.
        </div>
      } else {
        return <div class='payment-options__details u-margin-bottom-medium'>
          Sorry, Zip Money is not available. Complete your purchase using a different payment method or try again.
        </div>
      }
    }
  }

  renderSelectableOption () {
    const passengerBilingCountry = countries.findByName(this.payment.booking.booking.leadPassenger.address.country).alpha2
    const availableInCountry = this.enabledCountries.includes(passengerBilingCountry)
    const isAvailable = Boolean(this.paymentMethods.selected.zipMoney)
    const hasLoaded = this.paymentMethods.selected.hasLoaded
    const cssClasses = [
      'o-choice-item payment-options__item', {
        'has-discounts': this.payment.anyDiscounts(),
        '-selected': this.payment.paymentOption() === this,
      },
      'zip-money',
    ]

    let radioProps = {}
    if (!isAvailable || !availableInCountry) {
      cssClasses.push('disabled')
      radioProps = {disabled: 'disabled'}
    }

    if (hasLoaded) {
      cssClasses.push('loaded')
    }
    return <label class={cssClasses}>
      <input type='radio' class='o-choice-item__radio' name='payment-type'
        binding={[this.payment.paymentOptions, 'selected']}
        {...radioProps}
        value={this} />
      <div class='o-choice-item__content'>
        <h3 class='payment-options__heading'>
          {this.label}
          <span class='newPaymentOption'>NEW</span>
        </h3>
        <div class='clearfix u-margin-bottom-small'>
          {this.zipMoneyText(isAvailable, availableInCountry)}
          <div class='payment-options__logos'>
            <img class="zipmoney__logos__logo" src={assetPath(`/public/img/zipMoney.svg`)}/>
          </div>
        </div>
      </div>
    </label>
  }

  render (){
    return  (!this.hasFailed) ? this.renderSelectableOption() : undefined
  }
}
